import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { PatientCareCenterNoteObjectiveTemplateCheckBox } from './TemplateCheckBox';
import { PatientCareCenterNoteObjectiveCustomTemplate } from './CustomTemplate';
import { PatientCareCenterNoteObjectiveSpeechTemplate } from './Speech';
import { CheckBox } from '_components';
import styles from './Templates.module.css'

class PatientCareCenterNoteObjectiveTemplates extends React.Component {

    render() {
        return (
            <PatientCareCenterNoteSection id='obj_templates' name='Templates' level={1}>
                {this.props.globalTemplates.length > 0 &&
                    <PatientCareCenterNoteSection id='obj_templates_global' name='Global Templates' level={2}>
                        {this.props.isPeds && this.props.isPedsEnabled && !this.props.isPedsSpeech &&
                            < CheckBox
                                key={-3}
                                label={'Pediatrics'}
                                className={styles.checkbox}
                                checked={true}
                                disabled={true}
                            />
                        }
                        {this.props.isPedsSpeech && this.props.isSpeechEnabled &&
                            < CheckBox
                                key={-2}
                                label={'Speech - Peds'}
                                className={styles.checkbox}
                                checked={true}
                                disabled={true}
                            />
                        }
                        {this.props.isSpeech && !this.props.isPedsSpeech && this.props.isSpeechEnabled &&
                            < CheckBox
                                key={-1}
                                label={'Speech - Adult'}
                                className={styles.checkbox}
                                checked={true}
                                disabled={true}
                            />
                        }


                        {Object.keys(this.props.globalTemplates)
                            .map(key => {
                                const tmp = this.props.globalTemplates[key];
                                return (
                                    <PatientCareCenterNoteObjectiveTemplateCheckBox key={tmp.TENO} TENO={tmp.TENO} />
                                )
                            })
                        }
                    </PatientCareCenterNoteSection>
                }
                {(this.props.userTemplates.length > 0 || this.props.globalTemplateSelectedCount > 0) &&
                    <PatientCareCenterNoteSection id='obj_templates_user' name='My Templates' level={2}>
                        <PatientCareCenterNoteObjectiveCustomTemplate />
                        {Object.keys(this.props.userTemplates)
                            .map(key => {
                                const tmp = this.props.userTemplates[key];
                                return (
                                    <PatientCareCenterNoteObjectiveTemplateCheckBox key={tmp.ID} TENO={tmp.TENO} />
                                )
                            })
                        }
                    </PatientCareCenterNoteSection>
                }
                {this.props.isSpeechEnabled && this.props.isSpeech && <PatientCareCenterNoteObjectiveSpeechTemplate />}
            </PatientCareCenterNoteSection>
        );
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let type = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);

    let globalTemplates = Object.keys(state.entities.notes.PTOBJECTIVETEMPLATES)
        .filter(key => { return state.entities.notes.PTOBJECTIVETEMPLATES[key].TEURNO === null && state.entities.notes.PTOBJECTIVETEMPLATES[key].NoteId === noteId })
        .sort((a, b) => state.entities.notes.PTOBJECTIVETEMPLATES[a].TENAME.localeCompare(state.entities.notes.PTOBJECTIVETEMPLATES[b].TENAME))
        .map(key => state.entities.notes.PTOBJECTIVETEMPLATES[key]);

    let globalTemplateIds = Object.keys(globalTemplates).map(x => globalTemplates[x].TENO);

    let globalTemplateSelectedCount = Object.keys(state.entities.notes.PTOBJECTIVETEMPLATESXREF)
        .filter(x => (
            (type === 1 && state.entities.notes.PTOBJECTIVETEMPLATESXREF[x].OBEVNO === pk) ||
            (type !== 1 && state.entities.notes.PTOBJECTIVETEMPLATESXREF[x].OBNTNO === pk)
        ) && globalTemplateIds.includes(state.entities.notes.PTOBJECTIVETEMPLATESXREF[x].OBTENO)
        ).length;

    let noteType = parseInt(noteId.split("_")[0]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isPeds = state.entities.admissions[epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isSpeechEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;
    let isSpeech = state.entities.admissions[epno].discipline === "ST" ? true : false;
    let isPedsSpeech = state.entities.admissions[epno].isPedsSpeech;


    return {
        noteId,
        isPeds,
        isPedsEnabled,
        globalTemplates,
        isSpeechEnabled,
        globalTemplateSelectedCount,
        userTemplates: Object.keys(state.entities.notes.PTOBJECTIVETEMPLATES)
            .filter(key => { return state.entities.notes.PTOBJECTIVETEMPLATES[key].TEURNO !== null && state.entities.notes.PTOBJECTIVETEMPLATES[key].NoteId === noteId })
            .sort((a, b) => state.entities.notes.PTOBJECTIVETEMPLATES[a].TENAME.localeCompare(state.entities.notes.PTOBJECTIVETEMPLATES[b].TENAME))
            .map(key => state.entities.notes.PTOBJECTIVETEMPLATES[key]),
        isSpeech,
        isSpeechEnabled,
        isPedsSpeech
    };
}

const connectedPatientCareCenterNoteObjectiveTemplates = connect(mapStateToProps)(PatientCareCenterNoteObjectiveTemplates);
export { connectedPatientCareCenterNoteObjectiveTemplates as PatientCareCenterNoteObjectiveTemplates };

